export async function authGet(accessToken: string, path: string) {
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const res = await fetch(uri, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    
    // Check if the response was successful (2xx status codes)
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(`HTTP ${res.status}: ${errorData.error || res.statusText}`);
    }
    
    const name = await res.json();
    return name;
  } catch (err) {
    console.log(`GET request to uri ${uri} failed`);
    throw err; // Re-throw the error so it propagates to the caller
  }
}

export async function authPost(accessToken: string, path: string, body: any) {
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const res = await fetch(uri, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
    });
    
    // Check if the response was successful (2xx status codes)
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(`HTTP ${res.status}: ${errorData.error || res.statusText}`);
    }
    
    const name = await res.json();
    return name;
  } catch (err) {
    console.error(
      `POST request to uri ${uri} with body:\n${JSON.stringify(body, undefined, 4)} failed`
    );
    console.error(err);
    throw err; // Re-throw the error so it propagates to the caller
  }
}

export async function authPut(accessToken: string, path: string, body: any) {
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const res = await fetch(uri, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
    });
    
    // Check if the response was successful (2xx status codes)
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(`HTTP ${res.status}: ${errorData.error || res.statusText}`);
    }
    
    const name = await res.json();
    return name;
  } catch (err) {
    console.error(
      `PUT request to uri ${uri} with body:\n${JSON.stringify(body, undefined, 4)} failed`
    );
    console.error(err);
    throw err; // Re-throw the error so it propagates to the caller
  }
}

export async function authPatch(accessToken: string, path: string, body: any) {
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const res = await fetch(uri, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
    });
    
    // Check if the response was successful (2xx status codes)
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(`HTTP ${res.status}: ${errorData.error || res.statusText}`);
    }
    
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(
      `PATCH request to uri ${uri} with body:\n${JSON.stringify(body, undefined, 4)} failed`
    );
    console.error(err);
    throw err; // Re-throw the error so it propagates to the caller
  }
}

export async function authDelete(accessToken: string, path: string, body?: any) {
  const domain = import.meta.env.VITE_API_URL || '';
  const uri = domain + path;
  try {
    const res = await fetch(uri, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    
    // Handle 204 No Content responses
    if (res.status === 204) {
      return { success: true };
    }
    
    // Check if the response was successful (2xx status codes)
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(`HTTP ${res.status}: ${errorData.error || res.statusText}`);
    }
    
    // Check if response has content before parsing JSON
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const name = await res.json();
      return name;
    }
    
    // For other responses without JSON content
    return { success: true };
  } catch (err) {
    console.error(`DELETE request to uri ${uri} failed`);
    console.error(err);
    throw err; // Re-throw the error so it propagates to the caller
  }
}
export function authWebSocket(accessToken: string): WebSocket {
  const wsDomain = 'wss://tbkinro0j5.execute-api.eu-west-2.amazonaws.com/production';
  const tokenDomain = wsDomain + '?token=' + accessToken;

  const ws = new WebSocket(tokenDomain);

  // ws.onopen = () => {
  //   console.log(`WebSocket connection to ${wsDomain} opened`);
  //   // ws.send(JSON.stringify({ action: 'Hello' }));
  //   console.log('Message sent');
  // };

  // ws.onmessage = (event) => {
  //   console.log(`Message from server: ${event.data}`);
  // };

  ws.onerror = (error) => {
    console.log(error);
    console.error(`WebSocket error: ${error}`);
  };

  ws.onclose = (event) => {
    console.log(event);
    console.log(`WebSocket connection to ${wsDomain} closed: ${event.reason}`);
  };

  return ws;
}
